import { TextInput } from '../shared/TextInput';
import { FillInputProps } from '../fillInput';

const plusAndDigits = (typed: string) => typed.replace(/[^\d+]/g, '');

export const PhoneNumberInput = (props: FillInputProps<string, object>) => {
  return <TextInput {...props} inputMode="tel" keep={plusAndDigits} />;
};
